import React, { FunctionComponent } from 'react';
import { useIntl } from 'react-intl';
import { Image } from '@chakra-ui/react';
import { assetPrefix } from '../../../../../utils';

const CalculatorSquareMeterAverageCta: FunctionComponent = () => {
  const intl = useIntl();
  const headerText = intl.formatMessage({
    id: 'cta.image.alt',
    defaultMessage: 'Hoe zit het in mijn gemeente met de huizenprijzen?'
  });
  const { alt, src } = {
    src: '/assets/calculators/square-meter-average/images/apartment.png',
    alt: headerText
  };

  return (
    <div>
      <div className={`block`}>
        <Image className={`w-full`} alt={alt} src={`${assetPrefix}${src}`}></Image>
      </div>
    </div>
  );
};

export default CalculatorSquareMeterAverageCta;
